import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

const WhatsAppSettings = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-qr'),
      name: 'whatsapp_qr_index',
      component: WhatsAppSettings,
      meta: {
        permissions: ROLES,
      },
    },
  ],
};
